import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Building from '../views/Building'
import Analytics from '../views/Analytics'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/building/:buildingId',
    name: 'Building',
    props: true,
    component: Building
  },
  {
    path: '/analytics/:ids',
    name: 'Analytics',
    component: Analytics,
    props: true
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//global before navigation guard
router.beforeEach((to, from, next) => {
  const jwt = localStorage.getItem('jwt')
  if (to.name !== 'Login' && !jwt) {
    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router
